// extracted by mini-css-extract-plugin
export default {"wrap":"TransactionsMobBtn_wrap__yZP-d","link":"TransactionsMobBtn_link__qcAfW"};